module.exports = __webpack_public_path__ + "static/media/nav-emblen.4314db7b.svg";